<script setup lang="ts">
import { inject } from 'vue';

const isScrolled = inject('isScrolled', false)
</script>

<template>
  <div class="top-0 pb-2 pt-4 sticky z-[200]">
    <div
      class="flex gap-2 justify-between items-center p-2 rounded-lg -mx-2"
      :class="{'shadow-sm bg-white transition-colors duration-75 ease-in-out': isScrolled }"
    >
      <slot />
    </div>
  </div>
</template>
